import { Layout, OpenSans, zIndex } from '@easy-expense/ui-web-core';

/**
 * The floating explanation card shown above a hovered information symbol.
 *
 * Follows the app's existing floating-panel style (dark card, white text,
 * dropdown-style shadow/radius — see TopDropdown.component.tsx /
 * ColumnVisibilityPopover), and shows instantly with no native browser
 * tooltip delay.
 *
 * Kept separate from the symbol that triggers it so a caller can render the
 * panel outside a dimmed container (a disabled button) while the symbol
 * itself sits inside it — a nested panel would inherit the dimming and drop
 * below readable contrast.
 *
 * Positions itself against the nearest `position: relative` ancestor.
 */
export const TooltipPanel: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Layout.Column
      bg="buttonBlack"
      radius={8}
      py={8}
      px={10}
      style={{
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        marginBottom: 6,
        width: 220,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
        zIndex: zIndex.Dropdown,
      }}
    >
      <OpenSans.Inverse size="xs-12">{text}</OpenSans.Inverse>
    </Layout.Column>
  );
};
